module.exports = __webpack_public_path__ + "static/media/2.2_preview.bdcf0709.png";